import React, { useEffect, useState } from "react";

//UI Material
import {
  Button,
  CircularProgress,
  Grid,
  Stack,
  SwipeableDrawer,
  Typography,
} from "@mui/material";

//Local components
import Form from "../basics/Form";
import ModalWindow from "../Modal";

//Material Icons
import { Add, Cancel, Inventory } from "@mui/icons-material";

//Helpers
import { fetchWithTokenJSONPost } from "../../Helpers/network";

export default function SetSupplierDrawer({
  isNewSupplier,
  open,
  setOpen,
  getData,
  existingSupplierData = {},
}) {
  // ==========>Component States<==========
  //State for supplierData
  const [supplierData, setSupplierData] = useState({});
  //State fpr setting loader
  const [isLoading, setIsLoading] = useState(false);
  //State for open modal
  const [modalOpen, setModalOpen] = useState(false);
  //State for modal text
  const [modalText, setModalText] = useState("");
  //State for modal description
  const [modalDescription, setModalDescription] = useState("");

  const addSupplierForm = [
    {
      selection: "textfield",
      id: "name",
      initialValue: supplierData.name,
      xs: 12,
      md: 6,
      label: "Nombre del proveedor",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Nombre del proveedor",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "identification",
      initialValue: supplierData.identification,
      xs: 12,
      md: 6,
      label: "Identificación del proveedor",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Identificación del proveedor",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "address",
      initialValue: supplierData.address,
      xs: 12,
      md: 4,
      label: "Dirección y otras señas",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Dirección y otras señas",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "province",
      initialValue: supplierData.province,
      xs: 12,
      md: 4,
      label: "Provincia/Estado",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Provincia/Estado",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "country",
      initialValue: supplierData.country,
      xs: 12,
      md: 4,
      label: "País",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "País",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "email",
      initialValue: supplierData.email,
      xs: 12,
      md: 4,
      label: "Correo electrónico del proveedor",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Correo electrónico del proveedor",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "phoneNumber",
      initialValue: supplierData.phoneNumber,
      xs: 12,
      md: 4,
      label: "Número telefónico del proveedor",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Número telefónico del proveedor",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "additionalInfo",
      initialValue: supplierData.additionalInfo,
      xs: 12,
      md: 4,
      label: "Información adicional del proveedor",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Información adicional del proveedor",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "accountNumber",
      initialValue: supplierData.accountNumber,
      xs: 12,
      md: 6,
      label: "Número de cuenta bancaria",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Número de cuenta del proveedor",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "paymentType",
      initialValue: supplierData.paymentType,
      xs: 12,
      md: 6,
      label: "Tipo de pago",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Tipo de pago",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "paymentTerm",
      initialValue: supplierData.paymentTerm,
      xs: 12,
      md: 6,
      label: "Plazo de pago",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Plazo de pago",
      content: [],
      style: {},
    },
    {
      selection: "textfield",
      id: "deliveryTime",
      initialValue: supplierData.deliveryTime,
      xs: 12,
      md: 6,
      label: "Tiempo de entrega",
      multiline: false,
      type: "text",
      inputProps: {},
      placeholder: "Tiempo de entrega",
      content: [],
      style: {},
    },
  ];

  //Function to create new item
  const setSupplier = async () => {
    setIsLoading(true);

    const newItem = {
      id: existingSupplierData.id,
      name: supplierData.name,
      address: supplierData.address,
      province: supplierData.province,
      country: supplierData.country,
      identification: supplierData.identification,
      phoneNumber: supplierData.phoneNumber,
      email: supplierData.email,
      additionalInfo: supplierData.additionalInfo,
      accountNumber: supplierData.accountNumber,
      deliveryTime: supplierData.deliveryTime,
      paymentTerm: supplierData.paymentTerm,
      paymentType: supplierData.paymentType,
    };

    try {
      const requestResponse = await fetchWithTokenJSONPost(
        isNewSupplier
          ? "/inventory/create-supplier"
          : "/inventory/edit-supplier",
        newItem
      );
      const jsonResponse = await requestResponse.json();

      if (jsonResponse.status === "ok") {
        setModalText(
          isNewSupplier
            ? "Proveedor registrado exitosamente."
            : "Proveedor editado exitosamente."
        );
        setModalDescription(jsonResponse.description);
        getData();
        setOpen(false);
      } else {
        setModalText("No se pudo realizar la acción.");
        setModalDescription(jsonResponse.description);
      }
    } catch (error) {
      console.log(error);
    }
    setModalOpen(true);
    setIsLoading(false);
  };

  useEffect(() => {
    if (existingSupplierData && Object.keys(existingSupplierData).length > 0) {
      setSupplierData({
        name: existingSupplierData.name || "",
        address: existingSupplierData.address || "",
        province: existingSupplierData.province || "",
        country: existingSupplierData.country || "",
        identification: existingSupplierData.identification || "",
        phoneNumber: existingSupplierData.phoneNumber || "",
        email: existingSupplierData.email || "",
        additionalInfo: existingSupplierData.additionalInfo || "",
        accountNumber: existingSupplierData.accountNumber || "",
        deliveryTime: existingSupplierData.deliveryTime || "",
        paymentTerm: existingSupplierData.paymentTerm || "",
        paymentType: existingSupplierData.paymentType || "",
      });
    }
  }, [existingSupplierData]);

  return (
    <SwipeableDrawer
      anchor="bottom"
      transitionDuration={600}
      disableSwipeToOpen={true}
      open={open}
      sx={{
        zIndex: "99",
        "& .MuiDrawer-paper": {
          justifyContent: "center",
          borderRadius: "35px 35px 0px 0px",
        },
      }}
      onClose={() => setOpen(false)}
      onOpen={() => {
        /**empty arrow function */
      }}
    >
      <Grid
        container
        justifyContent="center"
        sx={{ padding: "15px" }}
        textAlign="center"
        spacing={1}
      >
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <Inventory color="secondary" />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h7" fontWeight="bold" color="secondary">
            {isNewSupplier
              ? `Nuevo proveedor`
              : `Editar información del proveedor`}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Form data={addSupplierForm} handleStateChange={setSupplierData} />
        </Grid>
        <Grid item xs={12} sx={{ marginTop: "10px" }}>
          <Stack direction="row" spacing={1} justifyContent="center">
            <Button
              size="small"
              variant="contained"
              color="error"
              sx={{ color: "white" }}
              endIcon={<Cancel />}
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancelar
            </Button>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <Button
                size="small"
                variant="contained"
                color="secondary"
                sx={{ color: "white" }}
                endIcon={<Add />}
                disabled={supplierData.name === ""}
                onClick={setSupplier}
              >
                {isNewSupplier ? "Registrar proveedor" : "Guardar cambios"}
              </Button>
            )}
          </Stack>
        </Grid>
      </Grid>
      <ModalWindow
        isOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
        title={modalText}
        text={modalDescription}
        leftText="OK"
        leftClick={() => {
          setModalOpen(false);
        }}
      />
    </SwipeableDrawer>
  );
}
